import React from "react";
import { Button, SIZE_MAP } from "./IconButton.styles";
import type { IconButtonProps } from "./IconButton.types";

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(({
  icon: Icon,
  "aria-label": ariaLabel,
  size = "md",
  tone = "default",
  active = false,
  bordered = false,
  variant = "default",
  $active = false,
  $placing = false,
  "aria-pressed": ariaPressed,
  title,
  disabled = false,
  "aria-disabled": ariaDisabled,
  "aria-describedby": ariaDescribedBy,
  onClick,
  type = "button",
  iconSize,
  className,
  "aria-haspopup": ariaHasPopup,
  "aria-expanded": ariaExpanded,
  tabIndex,
}, ref) => {
  const resolvedIconSize = iconSize ?? SIZE_MAP[size].icon;
  return (
    <Button
      ref={ref}
      aria-haspopup={ariaHasPopup}
      aria-expanded={ariaExpanded}
      tabIndex={tabIndex}
      type={type}
      $size={size}
      $variant={variant}
      $placing={$placing}
      $active={$active}
      $tone={tone}
      $ring={active}
      $bordered={bordered}
      disabled={disabled}
      aria-disabled={ariaDisabled || undefined}
      aria-describedby={ariaDescribedBy}
      onClick={ariaDisabled ? undefined : onClick}
      aria-label={ariaLabel}
      aria-pressed={ariaPressed}
      title={title === null ? undefined : title ?? ariaLabel}
      className={className}
    >
      <Icon size={resolvedIconSize} aria-hidden />
    </Button>
  );
});
IconButton.displayName = "IconButton";

export default IconButton;
